export let todayGroupHeader = "dCm_kd";
export let yesterdayGroupHeader = "STBPS";
export let thisWeekGroupHeader = "Kb_beb";
export let lastWeekGroupHeader = "SbQ65b";
export let twoWeeksAgoGroupHeader = "OvLpsd";
export let threeWeeksAgoGroupHeader = "khXRlc";
export let thisMonthGroupHeader = "Yunzbe";
export let lastMonthGroupHeader = "GZ2HSb";
export let olderGroupHeader = "oV3RWd";
export default {todayGroupHeader,yesterdayGroupHeader,thisWeekGroupHeader,lastWeekGroupHeader,twoWeeksAgoGroupHeader,threeWeeksAgoGroupHeader,thisMonthGroupHeader,lastMonthGroupHeader,olderGroupHeader};